module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title is-4"
  }, [_vm._v("\n      E-Coins Transfer\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-notification', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("\n      Your wallet address is "), _c('i', [_vm._v(_vm._s(_vm.address))])]), _vm._v(" "), _c('b-notification', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n      Any transfer is immediate and "), _c('strong', [_vm._v("irreversible")]), _vm._v(".\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n      Recipient\n    ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "type": _vm.validateBeneficiary
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "data": _vm.filteredDataArray,
      "field": "email",
      "placeholder": "Ex: 1LZbix…",
      "icon": "search",
      "type": "search",
      "loading": _vm.autocomplete.isFetching
    },
    on: {
      "select": function (option) { return _vm.autocomplete.selected = option; }
    },
    model: {
      value: (_vm.autocomplete.name),
      callback: function($$v) {
        _vm.$set(_vm.autocomplete, "name", $$v)
      },
      expression: "autocomplete.name"
    }
  })], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Amounts")]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.wallet), function(asset) {
    return _c('div', {
      staticClass: "tile is-parent is-4"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('h1', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(asset.name) + " E-Coin")]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('p', [_c('slider', {
      attrs: {
        "type": asset.color,
        "value": asset.amount,
        "max": asset.max,
        "step": 1,
        "is-fullwidth": ""
      },
      on: {
        "change": function($event) {
          return _vm.update($event, asset)
        }
      }
    })], 1), _vm._v(" "), _c('p', [_c('b-input', {
      staticClass: "is-small",
      attrs: {
        "type": "number",
        "min": "0",
        "max": asset.max
      },
      model: {
        value: (asset.amount),
        callback: function($$v) {
          _vm.$set(asset, "amount", $$v)
        },
        expression: "asset.amount"
      }
    })], 1)])])])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-field', [_c('p', {
    staticClass: "control level-right"
  }, [_c('button', {
    staticClass: "button is-warning",
    attrs: {
      "disabled": !_vm.ready
    },
    on: {
      "click": function($event) {
        _vm.isModalActive = true
      }
    }
  }, [_c('span', [_vm._v("Transfer")])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isModalActive,
      "width": 640
    },
    on: {
      "update:active": function($event) {
        _vm.isModalActive = $event
      }
    }
  }, [_c('form', [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Transfer confirmation")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('p', [_vm._v("\n            You are about to make the next transfer to " + _vm._s(_vm.autocomplete.selected) + "\n          ")]), _vm._v(" "), _vm._l((_vm.wallet), function(asset) {
    return (asset.amount > 0) ? _c('p', [_vm._v("\n            " + _vm._s(asset.amount) + " " + _vm._s(asset.name) + "\n          ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isModalActive = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validate
    }
  }, [_vm._v("Confirmer")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420182ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transfer.vue
// module id = 162
// module chunks = 0